/**
 * Garden Measurement Calculator — TypeScript entry point.
 * Handles auto-scrolling to results and hidden-iframe print flow.
 */
import { initIframePrint } from './shared/iframe-print';

function scrollToResult(): void {
    const resultIds = ['length-result', 'area-result', 'volume-result'];
    for (const id of resultIds) {
        const el = document.getElementById(id);
        if (el) {
            setTimeout(() => {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
            return;
        }
    }
}

function init(): void {
    scrollToResult();

    // Two print buttons sharing one iframe, one for conversions and one for coverage
    initIframePrint({
        formId: 'gmcConvPrintForm',
        iframeId: 'gmcPrintFrame',
        buttonId: 'gmcConvPrintBtn',
        readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Conversion Chart',
    });

    initIframePrint({
        formId: 'gmcCovPrintForm',
        iframeId: 'gmcPrintFrame',
        buttonId: 'gmcCovPrintBtn',
        readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Coverage Guide',
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
